module.exports = __webpack_public_path__ + "fonts/Alibaba_PuHuiTi_2.0_55_Regular_55_Regular.7d731481.ttf";